import React from 'react';
import { Route, Routes } from "react-router-dom";
import { routes, specialistRoutes } from "./routes";
import { useSelector } from "react-redux";
import NotFound from "../pages/NotFound/NotFound";




const AppRouter = () => {
    const currentUser = useSelector(state => state.currentUser.currentUser);

    return (
        <Routes>
            <Route path='*' element={<NotFound />} />

            {!currentUser.fields.employee_id ?
                routes.map(route =>
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                        exact={route.exact}
                    />
                )
                :
                specialistRoutes.map(route =>
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                        exact={route.exact}
                    />
                )}
        </Routes>
    );
};

export default AppRouter;
